<mat-form-field [appearance]="appearance" [ngClass]="className">
  <mat-label>{{ label | translate }}</mat-label>
  <input matInput (input)="onInputChange($event)" [value]="value" [disabled]="disabled" [required]="required">
  <ng-content select="[validation]"></ng-content>
  <ng-container *ngIf="validator && formSubmit">
    <ng-container *ngFor="let error of formControl?.errors | keyvalue;">
      <mat-error *ngIf="error?.value">
        <em class="fas fa-exclamation-circle mr-2"></em>
        {{ generalService?.getErrorMessage(label, error?.key) }}
      </mat-error>
    </ng-container>
  </ng-container>
</mat-form-field>
